<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-facing-decorator';
import IconComponent from '@/components/atoms/Icon.vue';
import { ITranslationData } from "webshop-modules/translation/translation-data.definition";
import { IconName } from "webshop-modules";
import { ButtonType } from './button-type.enum';

@Component({
  name: 'ButtonComponent',
  components: { IconComponent }
})
export default class ButtonComponent extends Vue {

  @Prop() public label: ITranslationData | string | undefined;
  @Prop() public secondaryLabel!: string;
  @Prop() public iconName: IconName | undefined;
  @Prop() public secondaryIconName: IconName | undefined;
  @Prop() public qaSelector: string | undefined;
  @Prop({ default: false }) public active!: boolean;
  @Prop({ default: ButtonType.Submit }) public type!: ButtonType;
  @Prop({ default: true }) public fullWidth!: boolean;

  public readonly ButtonType: typeof ButtonType = ButtonType;

  @Emit() public submit(event: Event): Event {
    return event;
  }

  public get isTranslationLabel(): boolean {
    return this.label !== undefined && typeof this.label !== 'string';
  }

  private handleClick(event: Event) {
    if (this.active) {
      this.submit(event);
    }
  }
}
</script>

<template>
    <button :type="[{ 'submit' : type === ButtonType.Submit }]"
            v-bind:class="[
                {
                    '-active': active, '-fullWidth': fullWidth,
                    '-increasedHeight': !!secondaryLabel,
                },
                '-' + type ]"
            v-on:click.stop="handleClick"
            class="a-button"
            :data-qa="qaSelector">
        <div v-bind:class="{'-centered': !iconName && !secondaryIconName}"
             class="a-button__content">
            <IconComponent v-if="iconName"
                           :icon-id="iconName"
                           v-bind:class="{'-large': !!secondaryLabel}"
                           class="a-button__primaryIcon" />
            <div class="a-button__labelContainer">
                <div class="a-button__primaryLabel">
                    <span v-if="isTranslationLabel" v-translate="label"></span>
                    <span v-else v-html="label"></span>
                </div>
                <div v-if="secondaryLabel" class="a-button__secondaryLabel">
                    <span v-html="secondaryLabel"></span>
                </div>
            </div>
            <IconComponent v-if="secondaryIconName"
                           v-bind:class="{'-large': !!secondaryLabel}"
                           :icon-id="secondaryIconName"
                           class="a-button__secondaryIcon"/>
        </div>
    </button>
</template>
